import React from 'react';
import _ from 'lodash';

const withScreenSize = Page =>
    class extends React.Component {
        constructor(props) {
            super(props);
            this.onResize = _.throttle(this.onResize, 100);
            this.state = { size: window.innerWidth };
        }

        onResize = () => {
            if (window.innerWidth !== this.state.size) {
                this.setState({ ...this.state, size: window.innerWidth });
            }
        };

        isMobile = () => this.state.size <= 500;

        componentDidMount() {
            window.addEventListener('resize', this.onResize);
        }

        componentWillUnmount() {
            this.onResize.cancel();
            window.removeEventListener('resize', this.onResize);
        }

        render() {
            return <Page {...this.props} isMobile={this.isMobile()} />;
        }
    };

export default withScreenSize;



// WEBPACK FOOTER //
// ./src/components/hoc/screenSize/index.jsx